module.exports = __webpack_public_path__ + "images/mastercard.adda3b9d70c151d89a03f9afe48a1122.svg";